<template>
  <div class="national-center-right">
    <div
      id="centerRight"
      class="map"
      :style="{ width: '100%', height: '100%' }"
    ></div>
  </div>
</template>

<script>
import axios from "axios";
import china from "../../../node_modules/echarts/map/json/china.json";
import jsonMap from "../../../node_modules/echarts/map/json/china-cities.json";
export default {
  data() {
    return {
      geoCoordMap: [],
      data: []
    };
  },
  components: {},
  methods: {
    // 获取交易市场分布走向图
    async getFishBaseCount() {
      let res = await this.$api.getFishBaseCount();
      if (res.data.length > 0) {
        res.data.map(ele => {
          // 寻找对象前四位id相等
          let Coordinates = jsonMap.features.find(item => {
            return this.interceptId(ele.areaCode) === this.interceptId(item.id);
          });
          // 没有四位id 相等，则寻找两位id相等
          if (!Coordinates) {
            Coordinates = jsonMap.features.find(item => {
              return (
                this.interceptId2(ele.areaCode) === this.interceptId2(item.id)
              );
            });
          }
          if (Coordinates) {
            this.geoCoordMap[ele.area] = Coordinates.properties.cp;
            this.data.push({
              name: ele.area,
              value: ele.count,
              nickName: Coordinates.properties.name
            });
          }
        });
      }
      this.initEchart();
    },
    // 截取ID前2位
    interceptId2(data) {
      return data.toString().substring(0, 2);
    },
    // 截取ID前四位
    interceptId(data) {
      return data.toString().substring(0, 4);
    },
    initEchart() {
      const mapChart = this.$echarts.init(
        document.getElementById("centerRight")
      );
      if (mapChart) {
        mapChart.showLoading({
          text: "数据获取中",
          textColor: "#fff",
          effect: "whirling",
          maskColor: "rgba(255, 255, 255, 0)"
        });
        mapChart.hideLoading();
        this.$echarts.registerMap("china", china);
        var convertData = data => {
          var res = [];
          for (var i = 0; i < data.length; i++) {
            var geoCoord = this.geoCoordMap[data[i].name];
            if (geoCoord) {
              res.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].value),
                nickName: data[i].nickName
              });
            }
          }
          return res;
        };
        var sizeFunction = function(x) {
          var y = 0;
          if (x > 10) {
            y = Math.sqrt(x / 2) + 0.1;
          } else {
            y = Math.sqrt(x) + 0.1;
          }
          return y * 10;
        };
        mapChart.setOption({
          title: {
            padding: 5,
            text: "养殖基地数(个)",
            x: "51%",
            textStyle: {
              color: "#fff",
              fontWeight: 400
            }
          },
          tooltip: {
            trigger: "item",
            showDelay: 0,
            transitionDuration: 0.2,
            formatter: function(params) {
              var value = (params.value[2] + "").split(".");
              return params.data.nickName + ": " + value;
            }
          },
          legend: {
            show: false,
            orient: "vertical",
            left: "left",
            data: [""]
          },
          visualMap: {
            left: "16%",
            top: "0%",
            right: "auto",
            bottom: "auto",
            min: 0,
            max: 20848,
            pieces: [
              {
                min: 10
              },
              {
                min: 8,
                max: 10
              },
              {
                min: 6,
                max: 8
              },
              {
                min: 4,
                max: 6
              },
              {
                min: 2,
                max: 4
              },
              {
                min: 0,
                max: 2
              }
            ],
            inRange: {
              color: [
                "#50A3BA",
                "#92BF7E",
                "#D2DA43",
                "#EFCA2F",
                "#e48c47",
                "#d94e5d"
              ]
            },
            textStyle: {
              color: "#fff"
            }
          },
          geo: {
            map: "china",
            zoom: 0.95,
            top: "10%",
            left: "40%",
            roam: true,
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                borderWidth: 0.5, // 区域边框宽度
                borderColor: "RGBA(26, 39, 59, 1)", // 区域边框颜色
                areaColor: "RGBA(40, 67, 108, 1)" // 区域颜色
              },
              emphasis: {
                borderWidth: 0.5,
                borderColor: "RGBA(26, 39, 59, 1)",
                areaColor: "#2a333d",
                shadowBlur: 10,
                shadowColor: "#000",
                shadowOffsetY: 3
              }
            }
          },
          selectedMode: "single",
          series: [
            {
              name: "交易市场分布",
              type: "effectScatter",
              mapType: "china",
              coordinateSystem: "geo",
              rippleEffect: {
                brushType: "stroke"
              },
              symbolSize: function(val) {
                return sizeFunction(val[2]);
              },
              hoverAnimation: true,
              data: convertData(this.data),
              itemStyle: {
                normal: {
                  color: "#FEC400",
                  borderWidth: 0.5, // 区域边框宽度
                  borderColor: "RGBA(26, 39, 59, 1)", // 区域边框颜色
                  areaColor: "RGBA(40, 67, 108, 1)" // 区域颜色
                },
                emphasis: {
                  borderWidth: 0.5,
                  borderColor: "RGBA(26, 39, 59, 1)",
                  areaColor: "RGBA(254, 196, 0, 1)"
                }
              },
              label: {
                show: false,
                emphasis: {
                  textStyle: {
                    fontSize: 13,
                    color: "#465469"
                  }
                }
              }
            }
          ]
        });
        window.addEventListener("resize", function() {
          mapChart.resize();
        });
      }
    }
  },
  mounted() {
    this.getFishBaseCount();
  }
};
</script>
<style lang="stylus" scoped>
.national-center-right {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
